module.exports = __webpack_public_path__ + "static/skip-82ff7d253eb60a4b986d7952b0d2fc3a.png";